import { Input } from '@startupquickstart/frontend';

import { StateDropdown } from './StateDropdown';

const US_COUNTRY_VALUES = ['us', 'usa', 'united states', 'united states of america'];

// Country inputs default to 'US' across forms, so treat empty as US.
// Not exported: it is only used below, and exporting a non-component alongside a
// component breaks Fast Refresh for this file (react-refresh/only-export-components).
// If another module ever needs it, move it to its own file rather than exporting here.
function isUsCountry(country?: string | null): boolean {
  const normalized = country?.trim().toLowerCase();
  if (!normalized) return true;
  return US_COUNTRY_VALUES.includes(normalized);
}

interface StateFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  /** Current country form value; non-US countries get a free-text input instead of the US state dropdown. */
  country?: string | null;
  placeholder?: string;
  className?: string;
  id?: string;
}

export function StateField({
  value,
  onChange,
  country,
  placeholder = 'Select State',
  className,
  id,
}: StateFieldProps) {
  if (isUsCountry(country)) {
    return (
      <StateDropdown
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
      />
    );
  }

  return (
    <Input
      id={id}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder="State / Province / Region"
      className={className}
    />
  );
}
